import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { createFirestoreInstance } from 'redux-firestore';

import { IntlProviderWrapper } from './IntlContext';
import { ThemeProviderWrapper } from './ThemeContext';

import firebase from './firebase';

import store from './store';

import * as serviceWorker from './serviceWorker';

import System from './System';

import { GlobalStyle } from './assets/Global.style';

import config from './config';
const env = process.env.REACT_APP_CLIENT_ENV || 'development';

const history = createBrowserHistory();

ReactDOM.render(
  <HelmetProvider>
    <IntlProviderWrapper>
      <ThemeProviderWrapper>
        <Router history={history}>
          <Provider store={store}>
            <ReactReduxFirebaseProvider
              firebase={firebase}
              config={config[env].reduxFirebaseConfig}
              dispatch={store.dispatch}
              createFirestoreInstance={createFirestoreInstance}
            >
              <GlobalStyle />
              <System />
            </ReactReduxFirebaseProvider>
          </Provider>
        </Router>
      </ThemeProviderWrapper>
    </IntlProviderWrapper>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.register();
